const everything = document.querySelector(".article__content");
let everythingString = everything.innerHTML.toString();
const largeImages = document.querySelectorAll(".large-img");
const doubleImages = document.querySelectorAll(".double-img");

largeImages.forEach((image) => {
    const newRow = `
        <div class="single-img">
            ${image.outerHTML}
        </div>`;

    everythingString = everythingString.replace("{img}", newRow);
})

for (let i = 0; i < doubleImages.length; i += 2) {
    let newRow;

    if (doubleImages[i] && doubleImages[i + 1]) {
        newRow = `
        <div class="double-img-row">
            ${doubleImages[i].outerHTML}
            ${doubleImages[i + 1].outerHTML}
        </div>`;
    } else if (doubleImages[i]) {
        newRow = `
        <div class="single-img">
            ${doubleImages[i].outerHTML}
        </div>`;
    }

everythingString = everythingString.replace("{double-img}", newRow);
}

everything.innerHTML = everythingString;